import { profileModuleQuery, useModule } from 'system/structure-modules';

export default function ProfileEditScreen() {
    const { EditProfile } = useModule(profileModuleQuery);
    return <EditProfile />;
}
